import _ from 'lodash';
const IDP_SELECT_KEY = 'last_idp_select';
const loadingKey = Symbol.for('element-loading');
export function isLoadingValue(value) {
    return value === loadingKey;
}
export function withLoadingValue(values) {
    return values.concat(loadingKey);
}
export function withoutLoadingValue(values) {
    return _.filter(values, value => {
        return value !== loadingKey;
    });
}
export function saveSelectedIDP(idp) {
    if (!idp) {
        return;
    }
    const data = JSON.stringify(idp);
    localStorage.setItem(IDP_SELECT_KEY, data);
}
export function restoreSelectedIDP() {
    const value = localStorage.getItem(IDP_SELECT_KEY);
    if (!value) {
        return [];
    }
    if (value) {
        try {
            return [JSON.parse(value)];
        }
        catch (e) {
            return [];
        }
    }
}
